( function () {
	'use strict';
	/* eslint-disable max-params */
	function ExportFile ( fileTypes, title, $modalInstance, moment, reportType, reportFileNames, generateFn, $scope, $timeout, fileNameOverride, exportService ) {
		/* eslint-enable max-params */
		var self        = this;
		var currentDate = moment().format( 'MM.DD.YY' );

		self.disableExport = false;
		self.showItemsList = exportService.exportOptions();

		function generate () {
			generateFn[ self.type ]( self.fileName, function () {
				self.disableExport = false;
				$scope.$apply();
			}, self.showDescription, exportService.formatShowOptions( self.showItemsList ) );
		}

		function exportData () {
			self.disableExport = self.type !== 'CSV';

			if ( self.disableExport ) {
				$timeout( function () {
					generate();
				} );
			} else {
				generate();
			}
		}

		function closeModal () {
			$modalInstance.close();
		}

		self.fileTypes      = fileTypes;
		self.title          = title;
		self.type           = fileTypes[ 0 ];
		self.closeModal     = closeModal;
		self.reportTypeName = reportFileNames[ reportType ];
		self.currentDate    = currentDate;
		self.reportType     = reportType;
		self.fileName       = fileNameOverride || self.reportTypeName + self.currentDate;
		self.exportData     = exportData;
	}

	angular.module( 'app' )
		.controller( 'ExportFile', ExportFile );

	ExportFile.$inject = [ 'fileTypes', 'title', '$modalInstance', 'moment', 'reportType', 'reportFileNames', 'generateFn', '$scope', '$timeout', 'fileNameOverride', 'exportService' ];
} )( );
